module["exports"] = [
  " s/n.",
  ", #",
  ", ##",
  " #",
  " ##"
];
